import React from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {convertCurrency} from '../../../../_gori/helpers/ConvertHelpers'
import {SERVICE_INFO} from '../../../../_gori/constants'
import {ShippingRate} from '../core/shippingCalculatorHelpers'

export const RateCard: React.FC<{
  rate: ShippingRate
  shippingFrom: string
  shippingTo: string
  onCreateClick: () => void
}> = ({rate, shippingFrom, shippingTo, onCreateClick}) => {
  const intl = useIntl()
  const serviceInfo = SERVICE_INFO[rate.service as keyof typeof SERVICE_INFO]
  const min = serviceInfo && 'minDeliveryDays' in serviceInfo ? serviceInfo.minDeliveryDays : ''
  const max = serviceInfo && 'maxDeliveryDays' in serviceInfo ? serviceInfo.maxDeliveryDays : ''
  const hasDeliveryDays = min !== '' && max !== ''
  const displayName = intl.formatMessage({
    id: `SERVICE_${rate.service.toUpperCase()}_NAME`,
    defaultMessage: rate.service.replace(/_/g, ' '),
  })
  const deliveryWindow = hasDeliveryDays
    ? intl.formatMessage(
        {
          id: `SERVICE_${rate.service.toUpperCase()}_WINDOW`,
          defaultMessage: 'No information available.',
        },
        {min, max}
      )
    : intl.formatMessage({
        id: 'NO_DELIVERY_INFO_AVAILABLE',
        defaultMessage: 'No information available.',
      })

  return (
    <div className='shipping-calc__rate-card p-5 bg-white align-self-stretch d-flex align-items-center justify-content-between rounded-2'>
      <div className='shipping-calc__rate-info d-flex align-items-center'>
        <img
          src={toAbsoluteUrl(`/media/gori/carrier-logos/${rate.carrier.toLowerCase()}.png`)}
          alt={rate.carrier}
          className='shipping-calc__carrier-icon rounded-1 flex-shrink-0'
        />
        <div className='shipping-calc__rate-details d-flex flex-column align-items-start flex-shrink-0'>
          <div className='color-blue-dark lh-normal fw-bolder fs-4'>{displayName}</div>
          <div className='shipping-calc__service-address fw-semibold'>
            {intl.formatMessage({id: 'FROM_COLON'})} {shippingFrom}
          </div>
          <div className='shipping-calc__service-address fw-semibold'>
            {intl.formatMessage({id: 'TO_COLON'})} {shippingTo}
          </div>
          <div className='shipping-calc__service-address fw-semibold'>{deliveryWindow}</div>
        </div>
      </div>
      <div className='d-flex align-items-center gap-3'>
        <div className='shipping-calc__customer-price fs-2 lh-normal'>
          {convertCurrency(rate.fees)}
        </div>
        <button
          className='shipping-calc__create-btn cursor-pointer py-3 px-5 lh-normal border-0 text-white fw-bolder d-flex justify-content-center align-items-center'
          onClick={onCreateClick}
        >
          {intl.formatMessage({id: 'CREATE'})}
        </button>
      </div>
    </div>
  )
}
